import { api } from './api'

const apiVersion = 'v2'

export const guestUser = api.injectEndpoints({
    endpoints: (builder) => ({
        requestAccessCode: builder.mutation({
            query: ({ emailAddress, organisationId }) => ({
                url: `/${apiVersion}/organisations/${organisationId}/webstorelogin`,
                method: 'POST',
                body: { emailAddress },
            }),
        }),
        validateAccessCode: builder.mutation({
            query: ({ code, emailAddress, organisationId }) => ({
                url: `/${apiVersion}/organisations/${organisationId}/webstorelogin/verify`,
                method: 'POST',
                body: { emailAddress, code },
            }),
        }),
    }),
})

export const { useRequestAccessCodeMutation, useValidateAccessCodeMutation } = guestUser
